import { getPhoneDigits, isValidBrazilianPhone } from "../../../utils"

export const normalizeBrazilianPhoneInputValue = (phone) => {
    const digits = getPhoneDigits(phone)

    if (!digits)
        return ""

    const fullNumber = `+${digits}`
    const brazilianNumber = `+55${digits}`

    if (isValidBrazilianPhone(fullNumber))
        return fullNumber

    if (isValidBrazilianPhone(brazilianNumber))
        return brazilianNumber

    const withoutTrunkPrefix = digits.replace(/^0+/, "")
    if (withoutTrunkPrefix !== digits) {
        const brazilianWithoutTrunkPrefix = `+55${withoutTrunkPrefix}`
        if (isValidBrazilianPhone(brazilianWithoutTrunkPrefix))
            return brazilianWithoutTrunkPrefix
    }

    if (digits.length === 12 && digits.startsWith("1")) {
        const withoutUsPrefix = digits.slice(1)
        const brazilianWithoutUsPrefix = `+55${withoutUsPrefix}`
        if (isValidBrazilianPhone(brazilianWithoutUsPrefix))
            return brazilianWithoutUsPrefix
    }

    return fullNumber
}
